import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'

import { REVENUE_SORT_COLUMNS } from './constants'

function TableOrdersHeader({ className, onFilter, sortBy, type }) {
  const { t: translate } = useTranslation()
  const nameValue = type === 'group' ? REVENUE_SORT_COLUMNS.CHANNEL_STORE_NAME : REVENUE_SORT_COLUMNS.STORE_NAME

  return (
    <div className={classNames('table-orders-header', className)}>
      <div className={classNames('row-wrapper flex-row', sortBy.order)}>
        <Box
          className={classNames('cell-title flex-row cursor-pointer', {
            'is-active': sortBy.value === nameValue,
          })}
          data-value={nameValue}
          onClick={onFilter}
        >
          <Box display="inline" className="category mobile-only" data-value={nameValue} onClick={onFilter} />
          {translate('revenue.website')}
        </Box>

        <Box
          className={classNames('cell cell-orders-value cursor-pointer', {
            'is-active': sortBy.value === REVENUE_SORT_COLUMNS.ORDERS_VALUE,
          })}
          data-value={REVENUE_SORT_COLUMNS.ORDERS_VALUE}
          onClick={onFilter}
        >
          {translate('tableOrders.ordersValue')}
        </Box>

        <Box
          className={classNames('cell cell-orders cursor-pointer', { 'is-active': sortBy.value === REVENUE_SORT_COLUMNS.ORDERS })}
          data-value={REVENUE_SORT_COLUMNS.ORDERS}
          onClick={onFilter}
        >
          {translate('tableOrders.orders')}
        </Box>

        <Box
          className={classNames('cell cell-order-value cursor-pointer', {
            'is-active': sortBy.value === REVENUE_SORT_COLUMNS.ORDER_VALUE,
          })}
          data-value={REVENUE_SORT_COLUMNS.ORDER_VALUE}
          onClick={onFilter}
        >
          {translate('tableOrders.orderValue')}
        </Box>

        <Box
          className={classNames('cell cell-orders-value-share cursor-pointer', {
            'is-active': sortBy.value === REVENUE_SORT_COLUMNS.ORDERS_VALUE_SHARE,
          })}
          data-value={REVENUE_SORT_COLUMNS.ORDERS_VALUE_SHARE}
          onClick={onFilter}
        >
          {translate('tableOrders.ordersValueShare')}
        </Box>

        <Box
          className={classNames('cell cell-orders-share cursor-pointer', {
            'is-active': sortBy.value === REVENUE_SORT_COLUMNS.ORDERS_SHARE,
          })}
          data-value={REVENUE_SORT_COLUMNS.ORDERS_SHARE}
          onClick={onFilter}
        >
          {translate('tableOrders.ordersShare')}
        </Box>
      </div>
    </div>
  )
}

TableOrdersHeader.propTypes = {
  className: PropTypes.string,
  onFilter: PropTypes.func,
  sortBy: PropTypes.object,
  type: PropTypes.string,
}

export default TableOrdersHeader
